import React, { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import $ from "jquery";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { LazyLoadImage } from "react-lazy-load-image-component";

// ==================== DATA ====================
const cards = [
  {
    rating: 5,
    content:
      "Ronak and his team handles multiple projects for our telecom channel partner. They develop and maintain our frontend part where we sell products online on desktop and mobile. They also take care of backend and database interactions. Some of our existing softwares shares the usage of same database so SprigStack team makes sure everything is in order. They have been part of our IT team for more than 2 years now and we are very happy with their services.",
    authorImg: "/images/AboutUs/Review/Yehoshua.svg",
    author: "Yehoshua Kotlar",
    position: "Resource Manager at TalkNSave – Israel",
  },
  {
    rating: 5,
    content:
      "We wanted to create web-cum-mobile application for our privileged client base. Our app was supposed to have limited but powerful features. SprigStack team came up with a perfect hybrid application idea which served all the purposes. Our app looks beautiful in desktop as well as modern in mobile. Moreover, users can also directly download our app from their mobile browsers which is amazing. Thanks team for a great work, our users love using our app.",
    authorImg: "/images/AboutUs/Review/Ali.png",
    author: "Ali Akram",
    position: "IT Manager at SMBAL – Dubai",
  },
  {
    rating: 5,
    content:
      "We needed fast and efficient desktop and mobile websites for our products to sell online. Ronak and team did a great job in achieving that for us. We have a picture perfect website now which has eased lots of our manual work automated since we use a different system in backend. Me and my team gets a lot of productive time on other productive tasks than manual data entry.",
    authorImg: "/images/AboutUs/Review/Ryan.svg",
    author: "Ryan Skidmore",
    position: "Director at Berger's TablePads - USA",
  },
  {
    rating: 5,
    content:
      "SprigStack is a WONDERFUL company. They have a positive attitude and bring joy to the project. They do high quality work. They delivered on time and UNDER budget. We couldn't be happier to have found them. This will be the first of many projects.",
    authorImg: "/images/AboutUs/Review/John.svg",
    author: "John Luginbill",
    position: "CEO at THE HEAVYWEIGHTS",
  },
  {
    rating: 5,
    content:
      "SprigStack successfully delivered high-quality outputs that met and exceeded the client’s expectations. The team boasted an ability to work very efficiently without compromising the quality of their work. Moreover, their communication skills, creative prowess, and tech-savviness were commendable.",
    authorImg: "/images/AboutUs/Review/Ryan.svg",
    author: "Kalpesh Dangar",
    position: "Founder, Recruitment Process Outsourcing Firm",
  },
  {
    rating: 5,
    content:
      "Everything in the software is working as imagined. We will every day lay down our plan and requirements in detail and every dev from their team will understand and deliver. All requirements our company had from booking tours to delivering them, can be handled efficiently now. Every milestone was delivered on and before time. Software developed by Sprigstack was better and efficient. They did a great Job!",
    authorImg: "/images/AboutUs/Review/Ryan.svg",
    author: "Wani Dev",
    position: "CEO, Fayanka Tech",
  },
  {
    rating: 5,
    content:
      "We’ve been working with SprigStack for several years now and couldn’t be happier with the partnership. As a result, we use them as our only third-party agency for this and new projects across our subsidiaries.",
    authorImg: "/images/AboutUs/Review/Jason.png",
    author: "Jason Barresi",
    position: "Executive at Merrymeeting, Inc",
  },
  {
    rating: 5,
    content:
      "The SprigStack team was great! They moved over 50 pages of content in a day. This would have taken me months to do. I am extremely pleased with their timelines of completion and how easy it was to work with them.",
    authorImg: "/images/AboutUs/Review/Will.png",
    author: "Will Hardison",
    position: "Owner at FanBase",
  },
  {
    rating: 5,
    content:
      "The project is still in progress, but SprigStack has been proactive in their approach and has provided excellent customer service. The team communicates effectively through in-person meetings and has been responding well to the client’s needs.",
    authorImg: "/images/AboutUs/Review/Ryan.svg",
    author: "Jitesh Mehta",
    position: "CEO, Birbal Sports",
  },
];

const videoCards = [
  {
    backgroundImg: "/images/AboutUs/Review/Bill.png",
    name: "Bill Burke",
    position: "Founder at BoxScore - USA",
    videoLink: "https://www.youtube.com/embed/2tdaEvZ9znw?autoplay=1",
  },
  {
    backgroundImg: "/images/AboutUs/Review/RyanT.svg",
    name: "Ryan Thomas",
    position: "Operations Manager at MarketWagon - USA",
    videoLink: "https://www.youtube.com/embed/dPdWTzngcwQ?autoplay=1",
  },
  {
    backgroundImg: "/images/AboutUs/Review/Josh.svg",
    name: "Josh",
    position: "General Manager at Tellos",
    videoLink: "https://www.youtube.com/embed/suR2KwSPuxc?si=hywGRt1TpTUE5GZi",
  },
];

function ReviewTextCard({ rating, content, authorImg, author, position }) {
  return (
    <div className="review-testimonial-card mobile-fixed-height">
      <div className="review-stars">
        {Array.from({ length: rating }).map((_, i) => (
          <span key={i}>★</span>
        ))}
      </div>
      <p className="review-card-content mb-0">" {content}"</p>
      <div className="review-card-author">
        <LazyLoadImage
          effect="blur"
          src={authorImg}
          alt={author}
          className="me-3 img-fluid"
        />
        <div className="review-author-info">
          <div className="review-author-name">{author}</div>
          <div className="review-author-pos">{position}</div>
        </div>
      </div>
    </div>
  );
}

function ReviewVideoCard({
  backgroundImg,
  name,
  position,
  videoLink,
  videoPlay,
  css,
}) {
  return (
    <div
      className={`review-video-frame w-100 ${css || ""}`}
      style={{ backgroundImage: `url(${backgroundImg})` }}
    >
      <div className="review-video-overlay" />
      <div className="review-video-center-content">
        <LazyLoadImage
          effect="blur"
          src="/images/AboutUs/Review/PlayButton.svg"
          alt="Play"
          className="review-video-play-btn"
          onClick={() => videoPlay(videoLink, name)}
        />
      </div>
      <div className="review-video-info">
        <div className="review-video-name">{name}</div>
        <div className="review-video-position">{position}</div>
      </div>
    </div>
  );
}

export default function Review() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const autoplayDelay = 4000;

  const { ref: sectionRef, inView } = useInView({
    triggerOnce: true,
    threshold: 0.4,
  });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (swiperRef.current) {
      if (inView) {
        swiperRef.current.autoplay.start();
      } else {
        swiperRef.current.autoplay.stop();
      }
    }
  }, [inView]);

  const videoPlay = (url) => {
    const iframe = `<iframe id="reviewVideoContainerRemove" width="100%" height="100%" src="${url}" allow="autoplay" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    $(".review-video-container").empty().append(iframe);
    $(".review-video-parent").removeClass("d-none").focus();
    $("body").addClass("stopScroll");
  };

  const videoClose = () => {
    $("#reviewVideoContainerRemove").remove();
    $(".review-video-parent").addClass("d-none");
    $("body").removeClass("stopScroll");
  };

  // ==================== MOBILE VIEW ====================
  if (isMobile) {
    const merged = [];
    const maxLen = Math.max(cards.length, videoCards.length);
    for (let i = 0; i < maxLen; i++) {
      if (cards[i]) merged.push({ type: "text", ...cards[i] });
      if (videoCards[i]) merged.push({ type: "video", ...videoCards[i] });
    }

    return (
      <div className="py-2 mx-3_5-0 px-3" ref={sectionRef}>
        <h2 className="about-heading mb-3 text-center">
          What Our Clients Think About us!
        </h2>

        <div className="review-swiper-wrapper">
          <Swiper
            modules={[Pagination, Autoplay]}
            autoplay={{ delay: autoplayDelay, disableOnInteraction: false }}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            pagination={{ clickable: true, el: ".review-swiper-pagination" }}
            slidesPerView={1}
            spaceBetween={16}
          >
            {merged.map((item, idx) => (
              <SwiperSlide key={idx}>
                {item.type === "text" ? (
                  <ReviewTextCard {...item} />
                ) : (
                  <ReviewVideoCard {...item} videoPlay={videoPlay} />
                )}
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="review-swiper-pagination" />
        </div>

        <div className="review-video-parent d-none">
          <div className="review-video-close-icon" onClick={videoClose}>
            ✕
          </div>
          <div className="review-video-container"></div>
        </div>
      </div>
    );
  }

  // ==================== DESKTOP VIEW ====================
  return (
    <div
      className="py-md-5 py-2 mx-3_5-0 px-3"
      ref={sectionRef}
      style={{ overflow: "hidden" }}
    >
      {/* HEADER */}
      <motion.div
        className="review-card-swiper-header"
        initial={{ y: -50, opacity: 0 }}
        animate={inView ? { y: 0, opacity: 1 } : {}}
        transition={{ delay: 0.1, duration: 0.35, ease: "easeOut" }}
      >
        <h2 className="about-heading mb-0">What Our Clients Think About us!</h2>
        <div className="review-card-swiper-nav">
          <button
            ref={prevRef}
            className={`review-nav-btn review-prev-btn ${
              canPrev ? "enabled" : "disabled"
            }`}
            disabled={!canPrev}
          >
            <LazyLoadImage
              effect="blur"
              src={
                canPrev
                  ? "/images/AboutUs/icons/prev-white.svg"
                  : "/images/AboutUs/icons/prev-grey.svg"
              }
              alt=""
            />
          </button>
          <button
            ref={nextRef}
            className={`review-nav-btn review-next-btn ${
              canNext ? "enabled" : "disabled"
            }`}
            disabled={!canNext}
          >
            <LazyLoadImage
              effect="blur"
              src={
                canNext
                  ? "/images/AboutUs/icons/next-white.svg"
                  : "/images/AboutUs/icons/next-grey.svg"
              }
              alt=""
            />
          </button>
        </div>
      </motion.div>

      {/* SLIDER */}
      <Swiper
        modules={[Navigation, Autoplay]}
        autoplay={{ delay: autoplayDelay, disableOnInteraction: false }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
          setTimeout(() => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.destroy();
            swiper.navigation.init();
            swiper.navigation.update();
            setCanPrev(!swiper.isBeginning);
            setCanNext(!swiper.isEnd);
          });
        }}
        navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
        slidesPerView={2}
        spaceBetween={18}
        allowTouchMove
        loop={false}
        onSlideChange={(swiper) => {
          setCanPrev(!swiper.isBeginning);
          setCanNext(!swiper.isEnd);
        }}
      >
        {cards.map((card, i) => (
          <SwiperSlide key={i}>
            <motion.div
              initial={
                i % 2 === 0 ? { x: -80, opacity: 0 } : { x: 80, opacity: 0 }
              }
              animate={inView ? { x: 0, opacity: 1 } : {}}
              transition={{
                duration: 0.4,
                delay: 0.25 + i * 0.12,
                ease: "easeOut",
              }}
            >
              <ReviewTextCard {...card} />
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* VIDEO CARDS */}
      <motion.div
        initial={{ y: 60, opacity: 0 }}
        animate={inView ? { y: 0, opacity: 1 } : {}}
        transition={{ delay: 0.6, duration: 0.4, ease: "easeOut" }}
        className="d-flex justify-content-between align-items-center mt-4"
      >
        {videoCards.map((item, i) => (
          <ReviewVideoCard
            key={i}
            {...item}
            videoPlay={videoPlay}
            css={i === 1 && "mx-5"}
          />
        ))}
      </motion.div>

      {/* Video Popup */}
      <div className="review-video-parent d-none">
        <div className="review-video-close-icon" onClick={videoClose}>
          ✕
        </div>
        <div className="review-video-container"></div>
      </div>
    </div>
  );
}
